import React, { useState, useCallback, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faVolleyball } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./header.css";

const Header = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    setDropdownOpen(false);
  };

  const onClickToProfile = useCallback(() => {
    navigate(`/profile`);
  }, [navigate]);

  useEffect(() => {
    const lang = i18n.language;

    document.body.classList.remove("lang-en", "lang-ps", "lang-fa");
    document.body.classList.add(`lang-${lang}`);
  }, [i18n.language]);


  return (
    <div
      className="bg-main-color bg-white border-bottom shadow"
      style={{
        padding: "2px 20px",
      }}
    >
      <div className="row">
        <div className="col-lg-10 col-md-9 col-sm-7 col-4 col-4 d-flex flex-column align-items-start justify-content-center">
          <img
            src="assets/NewMiniapp/logo-3.png"
            alt="Profile Icon"
            style={{ width: "70px", height: "56px" }}
          />
          <p className="mt-2 mb-0" style={{ fontSize: "10px", color: "#333" }}>
            {t("digitalHealth")}
          </p>
        </div>

        <div className="col-lg-1 col-md-1 col-sm-2 col-4 col-4 my-auto" onClick={onClickToProfile}>
          <div className="d-flex justify-content-center align-items-end mt-2">
            {/* <FontAwesomeIcon
                icon={faUser}
                style={{
                  width: "25px",
                  height: "25px",
                  color: "#950500",
                }}
              /> */}
            <img src="assets/NewMiniapp/User.svg" style={{ width: "25px" }} />
            <span
              className="ms-1 text-black"
              style={{ lineHeight: "16px" }}
            >{t("profile")}</span>
          </div>
        </div>
        <div className="col-lg-1 col-md-2 col-sm-3 col-4 col-4 my-auto">
          <div
            className="d-flex align-items-end justify-content-end"
            style={{ marginTop: "11px" }}
          >
            {/* Icon */}
            <img src="assets/NewMiniapp/Globe.svg" style={{ width: "25px" }} />


            <div className="dropdown custom-dropdown ms-1">
              <div
                className="dropdown-toggle custom-dropdown-header p-0"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{ cursor: "pointer" }}
                data-bs-toggle="dropdown"
                aria-expanded={dropdownOpen}
              >
                {t("selectedLanguage")}
              </div>

              <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButton">
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("en")}
                    style={{ cursor: "pointer" }}
                  >
                    English
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("ps")}
                    style={{ cursor: "pointer" }}
                  >
                    پشتو
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("fa")}
                    style={{ cursor: "pointer" }}
                  >
                    دری
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;